
import { Clock } from "lucide-react";

interface BlockedInCountryOverlayProps {
  exchange: string;
}

const BlockedInCountryOverlay = ({ exchange }: BlockedInCountryOverlayProps) => {
  return (
    <div className="absolute inset-0 bg-black/50 backdrop-blur-sm z-20 flex flex-col items-center justify-center p-6 rounded-xl">
      <Clock className="w-12 h-12 text-white/90 mb-2" />
      <h3 className="text-xl font-bold text-white text-center mb-1">Not Available</h3>
      <p className="text-white/80 text-center text-sm mb-3">
        This {exchange} strategy is currently not available in your country
      </p>
      
      {/* Exchange Logo */}
      <div className="bg-white/10 p-2 rounded-lg flex items-center justify-center">
        <img 
          src={`/lovable-uploads/6a93bfa2-7afa-404d-8a62-9c96df3c95ee.png`}
          alt={`${exchange} logo`}
          className="h-5 w-auto object-contain"
        />
      </div>
    </div>
  );
};

export default BlockedInCountryOverlay;
